import type { Catalog } from 'commons/modules/service/catalogsV2';
import { createReportSlice } from './reportStore';

// Initial filter keys for Homologation report
const initialFilters = {
  institute: '',
  operationType: '',
  classification: '',
};

// Create generic slice instance for this report
const slice = createReportSlice<Catalog>(
  'operationHomologation',
  initialFilters,
);

// Reducer
export default slice.reducer;
